import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { CharTypeNamePipe } from "rl-common/pipes/char-type-name.pipe";
import { ISourceField } from "rl-common/services/entity-config/entity-config.models";

@Component({
	selector: "rl-source-field-used-in-panel",
	templateUrl: "./source-field-used-in-panel.component.html",
	styleUrls: ["./source-field-used-in-panel.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CharTypeNamePipe]
})
export class SourceFieldUsedInPanelComponent {

	@Input()
	sourceField: ISourceField = null;

	constructor() { }
}